module.exports = __webpack_public_path__ + "static/media/Jaime_Alberto_Cantu_Gonzalez.2bd4c127.jpg";